// This file contains the pure function for matching a menu item ID by path.
// It is intentionally kept separate from TowerMenuUtils/TowerLayoutUtils to avoid dependency issues
// and to enable isolated unit testing without importing unrelated constants or modules.

export const getMenuItemIdByMapping = (path: string, idToUrlMap: Record<string, string>): string | undefined => {
    const sortedEntries = Object.entries(idToUrlMap).sort((a, b) => b[1].length - a[1].length);
    for (const [itemId, url] of sortedEntries) {
        if ((url === '/' && path === '/') || (url !== '/' && (path === url || path.startsWith(url + '/')))) {
            return itemId;
        }
    }
    return undefined;
};
